export class NumberFormatUtil {
	public static format(value?: unknown, numberOfDecimalPlaces = 1): string {
		if (typeof value == "number") {
			const formatted = new Intl.NumberFormat('de-DE', {
			  minimumFractionDigits: numberOfDecimalPlaces,
			  maximumFractionDigits: numberOfDecimalPlaces,
			}).format(value)
			
			return formatted;
		}
		
		return "";
	}
}
